export default __webpack_public_path__ + "static/umiru-dba16bcd4285118f888817c9ccea6530.pdf";